module.exports = __webpack_public_path__ + "img/spiral-anticlockwise-top-right.ff52e548.png";